import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type StoreType = 'korean' | 'chinese' | 'japanese' | 'western' | 'cafe' | 'lunchbox' | 'kimbap' | 'salad' | 'bakery' | 'buffet' | 'etc';

interface FilterState {
  selectedStoreTypes: StoreType[];
  showOpenOnly: boolean;
  showClosedOnly: boolean;
  setSelectedStoreTypes: (types: StoreType[]) => void;
  setShowOpenOnly: (value: boolean) => void;
  setShowClosedOnly: (value: boolean) => void;
  clearFilters: () => void;
}

export const useFilterStore = create<FilterState>()(
  persist(
    (set) => ({
      selectedStoreTypes: [],
      showOpenOnly: false,
      showClosedOnly: false,
      
      setSelectedStoreTypes: (types) => set({ selectedStoreTypes: types }),
      setShowOpenOnly: (value) => set({ showOpenOnly: value }),
      setShowClosedOnly: (value) => set({ showClosedOnly: value }),
      
      clearFilters: () => set({
        selectedStoreTypes: [],
        showOpenOnly: false,
        showClosedOnly: false,
      }),
    }),
    {
      name: 'filter-storage',
    }
  )
);